<template>
  <el-dialog
    style="text-align: center;"
    class="new-data-form"
    :title="title"
    :visible.sync="visible"
    :before-close="handleCancelClick"
  >
    <el-form class="form" :model="form" :rules="rules" ref="ruleForm">
      <el-form-item
        class="formItem"
        v-for="item in formContent"
        :label="item.label"
        :key="item.value"
        :prop="item.prop || item.value"
      >
        <el-input
          v-if="item.type === 'input'"
          v-model="form[item.value]"
          placeholder="请输入"
          :disabled="item.disabled"
          clearable
        />
        <el-input
          v-if="item.type === 'textarea'"
          v-model="form[item.value]"
          type="textarea"
          placeholder="请输入"
          :disabled="item.disabled"
          clearable
        />
        <el-select
          v-else-if="item.type === 'select'"
          v-model="form[item.value]"
          :disabled="item.disabled"
          :multiple="item.multiple"
          :filterable="item.filterable"
          style="width:100%"
          placeholder="请选择"
          clearable
          @change="selectChange(item, $event)"
        >
          <el-option
            v-for="(subItem, index) in item.option"
            :key="index"
            :label="subItem.label || subItem"
            :value="subItem.value || subItem"
          ></el-option>
        </el-select>
        <el-date-picker
          v-else-if="item.type === 'date' || item.type === 'monthrange'"
          v-model="form[item.value]"
          style="width:100%"
          :disabled="item.disabled"
          :type="item.type"
          :picker-options="item.picker"
          placeholder="请选择"
          clearable
        >
        </el-date-picker>
        <yl-cascader
          v-else-if="item.type === 'cascader'"
          v-model="form[item.value]"
          :options="item.option"
          :show-all-levels="false"
          placeholder="请选择"
          style="width: 100%"
          filterable
          clearable
          @change="cascaderChange"
        >
        </yl-cascader>
      </el-form-item>
    </el-form>

    <div class="upload">
      <el-button style="margin-right:20px" @click="dialogVisible = true"
        >上传附件
      </el-button>
      <div class="attachments">
        <div
          v-for="(item, index) of form.attachIds"
          :key="index"
          class="attachment"
        >
          <a @click="preViewAttachment(item)">{{
            item.attachmentOriginalName
          }}</a>
          <el-button
            type="text"
            size="small"
            class="el-icon-close"
            @click="removeAttachment(index)"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="btns">
      <el-button type="primary" size="small" @click="handleConfirmClick">
        确定
      </el-button>
      <el-button type="default" size="small" @click="handleCancelClick">
        取消
      </el-button>
    </div>
    <!-- 附件预览弹窗 -->
    <dialog-preview
      :preViewObj="preViewObj"
      :showPreview="showPreview"
      @handleClosePreview="showPreview = false"
    />
    <historical-attachment
      :dialogVisible.sync="dialogVisible"
      @AddAttachment="AddAttachment"
    />
  </el-dialog>
</template>

<script>
import cookie from "@/utils/cookie";
export default {
  name: "NewDataForm",
  components: {},
  props: {
    title: {
      type: String,
      default: "新增一条数据"
    },
    visible: {
      type: Boolean,
      default: false
    },
    formContent: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      attachmentsMultipart: [],
      showPreview: false,
      dialogVisible: false,
      preViewObj: {}
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleConfirmClick() {
      if (!this.validateFileForm()) {
        this.$message.warning("校验不通过，请检查其内容！");
        return;
      }
      this.$emit("handleConfirmClick", this.attachmentsMultipart);
      this.$emit("update:visible", false);
      this.$refs["ruleForm"].resetFields();
      this.attachmentsMultipart = [];
    },
    handleCancelClick() {
      if (this.validateFileForm()) {
        this.warnDialog();
      } else {
        this.$emit("handleCancelClick");
        this.$emit("update:visible", false);
        this.$refs["ruleForm"].resetFields();
        this.attachmentsMultipart = [];
      }
    },
    warnDialog() {
      const h = this.$createElement;
      this.$confirm("提示", {
        message: h("p", null, [
          h(
            "p",
            { style: "font-size: 18px;line-height: 40px;" },
            "有内容没有保存，是否保存并退出编辑？"
          ),
          h(
            "p",
            { style: "font-size: 14px;color: #00000069;" },
            "放弃修改，更新的内容不会自动保存"
          )
        ]),
        distinguishCancelAndClose: true,
        confirmButtonText: "保存",
        cancelButtonText: "放弃",
        type: "warning"
      })
        .then(() => {
          this.handleConfirmClick();
        })
        .catch(action => {
          if (action !== "cancel") return;
          this.$emit("handleCancelClick");
          this.$emit("update:visible", false);
          this.$refs["ruleForm"].resetFields();
          this.attachmentsMultipart = [];
        });
    },
    //移除附件
    removeAttachment(index) {
      if (!this.form.attachIds[index].id) {
        this.attachmentsMultipart.splice(index, 1);
      }
      this.form.attachIds.splice(index, 1);
    },
    AddAttachment(files, attachmentsMultipart) {
      if (attachmentsMultipart)
        this.attachmentsMultipart.push(...attachmentsMultipart);

      files.forEach(item => {
        if (item.uid) {
          item.localUrl = item.url;
        }
        this.form.attachIds.push(item);
      });
    },
    cascaderChange(value) {
      this.$emit("cascaderChange", value);
    },
    selectChange(item, value) {
      if (item.emit) this.$emit("selectChange", value);
    },
    //点击查看按钮
    preViewAttachment(item) {
      this.preViewObj = item;
      if (item.localUrl) {
        this.preViewObj.url = item.localUrl;
      } else {
        this.preViewObj.url =
          window.config.api.baseUrl +
          "/eims-api/attachment/findFile?token=" +
          cookie.getCookie("token") +
          "&code=" +
          item.code;
      }
      this.showPreview = true;
    },
    //规则校验
    validateFileForm() {
      let result = false;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          result = true;
        }
      });
      return result;
    }
  }
};
</script>
<style lang="scss" scoped>
.new-data-form {
  .form {
    display: flex;
    flex-wrap: wrap;
    max-height: 45vh;
    overflow: auto;
    margin-bottom: 10px;
    .formItem {
      width: 45%;
      margin-left: 3%;
    }
  }
  .upload {
    .attachments {
      max-height: 15vh;
      overflow: auto;
      margin-top: 10px;
      .attachment {
        cursor: pointer;
      }
      .attachment:hover {
        color: #2866e3;
        text-decoration: underline;
      }
    }
  }
  .btns {
  }
}
/deep/.el-dialog__wrapper {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NewDataForm.vue